import { Component, DestroyRef, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { IconComponent } from 'app/shared/icon/icon.component';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { DialogService } from 'app/shared/dialog/dialog.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FriendEvent, IFriend } from '../model/friends.model';
import { MatButton } from '@angular/material/button';
import { FriendsCrudService } from '../service/friends-crud.service';

@Component({
  selector: 'app-friends-action-menu',
  standalone: true,
  imports: [IconComponent, MatMenu, MatMenuTrigger, MatMenuItem, MatButton],
  templateUrl: './friends-action-menu.component.html',
  styleUrls: ['./friends-action-menu.component.scss'],
})
export class FriendsActionMenuComponent {
  @Input() friend!: IFriend;
  @ViewChild(MatMenuTrigger) menuTrigger!: MatMenuTrigger;
  @Output() eventTriggered = new EventEmitter();

  private friendsCrudService = inject(FriendsCrudService);
  private dialogService = inject(DialogService);
  private destroyRef = inject(DestroyRef);

  onMenuClick(event: Event): void {
    event.stopPropagation();
  }

  shareTo(event: Event) {
    event.stopPropagation();

    this.friendsCrudService.shareTo(this.friend.id.toString()).subscribe((response) => {
      this.eventTriggered.emit(FriendEvent.ShareTo);
      this.menuTrigger.closeMenu();
    });
  }

  stopSharingFrom(event: Event) {
    event.stopPropagation();

    this.friendsCrudService.stopShareFrom(this.friend.id.toString()).subscribe((response) => {
      this.eventTriggered.emit(FriendEvent.StopSharingFrom);
      this.menuTrigger.closeMenu();
    });
  }

  removeFriend(event: Event) {
    event.stopPropagation();
    this.menuTrigger.closeMenu();

    this.dialogService
      .deleteDialog('', 'Are you sure?', 'Do you want to remove @' + this.friend.userName + ' from friends?')
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        if (!result) return;

        this.friendsCrudService.removeFromFriends(this.friend.id.toString()).subscribe(() => {
          this.eventTriggered.emit(FriendEvent.Removed);
          this.menuTrigger.closeMenu();
        });
      });
  }
}
